export default "__VITE_ASSET__9cce9dd9__"